import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';
import Keycloak from 'keycloak-js';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (
    route,
    state
) => {
    const router: Router = inject(Router);
    const keycloak: Keycloak=inject(Keycloak);
    // Check the authentication status
    if (keycloak.authenticated) {
        return of(router.parseUrl(''));
    }
    // Allow the access
    return of(true);

};
